import {Command} from 'substance'
import {Event} from '../../lib/constants/Event'

class EscapeCommand extends Command {
    getCommandState() {
        return true
    }

    execute(params) {
        params.api.events.trigger(
            '__internal',
            Event.USERACTION_KEY_ESCAPE,
            {}
        )
    }
}

export {EscapeCommand}
